import { useScrollReveal } from "@/hooks/useScrollReveal";
import SiteFooter from "./SiteFooter";

interface Protocol {
  title: string;
  description: string;
}

const ProtocolTile = ({ protocol, index }: { protocol: Protocol; index: number }) => {
  const { ref, isVisible } = useScrollReveal(0.15);

  return (
    <div
      ref={ref as React.RefObject<HTMLDivElement>}
      className={`glass-tile scanline p-6 md:p-8 transition-all duration-700 ease-out ${
        isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"
      }`}
      style={{ transitionDelay: `${index * 80}ms` }}
    >
      <h3 className="text-caption uppercase tracking-[0.2em] text-foreground mb-4 relative z-10">
        {protocol.title}
      </h3>
      <p className="text-body text-dim leading-relaxed relative z-10">
        {protocol.description}
      </p>
    </div>
  );
};

const MethodSection = () => {
  const protocols: Protocol[] = [
    {
      title: "Triple Consent Protocol",
      description: "Active research into non-coercive data collection.",
    },
    {
      title: "Cultural Authority",
      description: "Decentralizing governance to the source.",
    },
    {
      title: "Diaspora Signal Ethics",
      description: "Encrypted signals for the displaced.",
    },
    {
      title: "Individual Ownership",
      description: "Personal sovereignty over identity data.",
    },
    {
      title: "Non-Surveillance Intelligence",
      description: "Ethical monitoring without extraction.",
    },
    {
      title: "Memory Preservation Systems",
      description: "Archival infrastructure for the unrecorded.",
    },
  ];

  return (
    <div className="w-full h-full overflow-y-auto">
      <section className="py-16 px-6 md:px-10">
        <div className="max-w-5xl mx-auto">
          <div className="border-t-2 border-rule pt-8 mb-16">
            <h2 className="text-caption text-dim uppercase tracking-[0.2em]">Method</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-0">
            {protocols.map((protocol, index) => (
              <ProtocolTile key={index} protocol={protocol} index={index} />
            ))}
          </div>
        </div>
      </section>

      <SiteFooter />
    </div>
  );
};

export default MethodSection;
